import type { OnboardingDataSlice } from './onboarding.type'

export const onboardingInitialState: OnboardingDataSlice = {
  isOnboarding: false,
  currentStep: null,
  error: null,
}
